import React from 'react';
import styled from 'styled-components';
import { Card, Text, AtlasButton, Spacer, Box } from '../..';
import sx from '../../sx';

/**
 * Every Getting Started page Core Features Card provides links that give users actions to take.
 *
 * Those actions can be internal, external, or addon actions.
 */

/**
 * The type of analytics metrics your application collects.
 */

const CoreFeaturesCard = ({
  title,
  caption,
  imgAlt,
  imgUrl,
  primaryAction,
  secondaryAction,
  actionHandler
}) => {
  return /*#__PURE__*/React.createElement(StyledCard, {
    sx: {
      borderRadius: '4px',
      border: '1px solid',
      borderColor: 'border.subtle',
      backgroundColor: 'card.background',
      width: '308px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement(Card.Media, {
    src: imgUrl,
    alt: imgAlt
  }), /*#__PURE__*/React.createElement(Card.Content, {
    sx: {
      px: '4',
      pt: '4',
      pb: '3',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start'
    }
  }, /*#__PURE__*/React.createElement(Card.Header, null, /*#__PURE__*/React.createElement(Text, {
    as: "h2",
    sx: {
      fontSize: 4,
      fontWeight: 'fontWeights.3',
      color: 'text.default'
    }
  }, title)), /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Text, {
    as: "p",
    fontSize: 2,
    sx: {
      marginTop: '10px',
      color: 'text.subtle',
      fontWeight: 'fontWeights.2',
      lineHeight: 'default'
    }
  }, caption)), /*#__PURE__*/React.createElement(Card.Footer, {
    sx: {
      padding: '24px 0 0 0',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginTop: 'auto',
      justifyContent: 'space-between',
      fontSize: '2'
    }
  }, /*#__PURE__*/React.createElement(AtlasButton, {
    appearance: `primary`,
    as: "button",
    sx: {
      fontWeight: 'bold'
    }
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    ,
    onClick: () => actionHandler ? actionHandler(primaryAction) : null,
    "data-testid": "cfc-card-btn-primary"
  }, primaryAction === null || primaryAction === void 0 ? void 0 : primaryAction.label), /*#__PURE__*/React.createElement(Spacer, {
    axis: "vertical",
    size: 8
  }), /*#__PURE__*/React.createElement(AtlasButton, {
    appearance: `subtle-link`,
    as: "a",
    target: "_blank",
    rel: "noopener noreferrer",
    href: secondaryAction === null || secondaryAction === void 0 ? void 0 : secondaryAction.url,
    sx: {
      color: 'text.subtlest',
      paddingLeft: '0px!important'
    }
  }, /*#__PURE__*/React.createElement(Box, {
    as: "span",
    sx: {
      display: 'flex',
      alignItems: 'baseline',
      justifyContent: 'center'
    }
  }, /*#__PURE__*/React.createElement(SVG, {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 17H5V7H6V5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19H6V17ZM19 10.005V19H9V5H14.99V7.49C14.99 7.68698 15.0288 7.88204 15.1042 8.06402C15.1796 8.24601 15.2901 8.41137 15.4293 8.55066C15.5686 8.68995 15.734 8.80044 15.916 8.87582C16.098 8.9512 16.293 8.99 16.49 8.99H20.99V8.468C20.99 8.171 20.858 7.89 20.631 7.7L15.557 3.464C15.197 3.164 14.744 3 14.275 3H9C8.46957 3 7.96086 3.21071 7.58579 3.58579C7.21071 3.96086 7 4.46957 7 5V19C7 19.5304 7.21071 20.0391 7.58579 20.4142C7.96086 20.7893 8.46957 21 9 21H19C19.5304 21 20.0391 20.7893 20.4142 20.4142C20.7893 20.0391 21 19.5304 21 19V10.005H19Z",
    fill: "currentColor"
  })), ' ', /*#__PURE__*/React.createElement(Spacer, {
    size: 12,
    axis: `horizontal`
  }), "Documentation")))));
};
CoreFeaturesCard.displayName = "CoreFeaturesCard";
const StyledCard = styled(Card).withConfig({
  displayName: "CoreFeaturesCard__StyledCard",
  componentId: "sc-djcksw-0"
})(["", ""], sx);
const SVG = styled.svg.withConfig({
  displayName: "CoreFeaturesCard__SVG",
  componentId: "sc-djcksw-1"
})(["display:block;user-select:none;overflow:visible;"]);
export default CoreFeaturesCard;